import { Collapse, List, Typography } from '@mui/material';
import { GrammarReplacement } from 'features/augmented-writing/augmented-writing.types';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import TextSuggestion from './text-suggestion';

interface Props {
  grammarReplacement: GrammarReplacement;
  active: boolean;
  /** 'default' keeps the legacy card, 'panel' renders the two-zone panel design */
  variant?: 'default' | 'panel';
  /** Hides the option list – used when the panel card offers a single "apply" button */
  hideOptions?: boolean;

  insertAtPosition(word: string, pos: number | number[]): () => void;
}

const GrammarContent: React.FC<Props> = ({ grammarReplacement, active, variant = 'default', hideOptions, insertAtPosition }) => {
  const { classes } = useStyles();

  const isPanel = variant === 'panel';
  const firstOption = !_.isEmpty(grammarReplacement.suggestions) ? grammarReplacement.suggestions[0] : undefined;

  return (
    <div>
      {isPanel && hideOptions && !_.isNil(firstOption) ? (
        <Typography className={classes.panelReplacement}>{firstOption.content}</Typography>
      ) : null}
      <Typography className={isPanel ? classes.panelExplanation : classes.explanation}>{grammarReplacement.text}</Typography>
      {!hideOptions ? (
        <Collapse in={active}>
          <List disablePadding={true}>
            {grammarReplacement.suggestions.map((suggestion, index) => (
              <TextSuggestion
                key={index}
                suggestion={suggestion}
                position={grammarReplacement.highlightPosition}
                variant={variant}
                insertAtPosition={insertAtPosition}
              />
            ))}
          </List>
        </Collapse>
      ) : null}
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  explanation: {
    fontSize: theme.typography.pxToRem(11),
    marginBottom: '8px',
  },
  panelExplanation: {
    fontSize: theme.typography.pxToRem(13),
    lineHeight: 1.5,
    color: theme.palette.greys.medium,
    textWrap: 'pretty',
  },
  panelReplacement: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.5,
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: '10px',
  },
}));

export default GrammarContent;
